import { render, staticRenderFns } from "./InnovationManagement.vue?vue&type=template&id=63c2b600"
import script from "./InnovationManagement.vue?vue&type=script&lang=js"
export * from "./InnovationManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports